// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__sMAaS","primary":"Block_primary__opNh9","fourth":"Block_fourth__SYMn2","blockInner":"Block_blockInner__gpvSK"};